import type { PiniaColadaPlugin } from '@pinia/colada';

/**
 * Makes `queryCache.refresh()` start a new fetch instead of reusing a pending call that was already
 * aborted. Colada (≤1.4.8, unfixed on main) aborts a pending fetch when its last tracker unmounts
 * but keeps `entry.pending` until the call settles; a remount in that window re-awaits the aborted
 * call, which never writes state, so the query sits in `pending` until something else refetches.
 */
export function PiniaColadaRefreshAbortedPending(): PiniaColadaPlugin {
  return ({ queryCache }) => {
    const refresh = queryCache.refresh;
    queryCache.refresh = (entry, options = entry.options) => {
      const aborted = entry.pending?.abortController.signal.aborted;
      if (aborted && (entry.state.value.error || entry.stale)) {
        return queryCache.fetch(entry, options);
      }
      return refresh(entry, options);
    };
  };
}
